import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";
import {WebfleetReportPage} from "../webfleet-report/webfleet-report";

/**
 * Generated class for the WebfleetReportOverviewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-webfleet-report-overview',
  templateUrl: 'webfleet-report-overview.html',
})
export class WebfleetReportOverviewPage {

  title: string = 'Tagesberichte';
  data: any;
  week: any = 1;
  year: any = new Date().getFullYear();
  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider, public alertCtrl: AlertController) {
    this.week = this.getWeek();
    console.log("load week");
    console.log(this.week);
    //this.loadOverview();
  }

  ionViewDidEnter() {
    this.loadOverview();
  }

  loadOverview() {
    this.teamappProvider.http_request('action=get_driver_times&week='+this.week, 'webfleet', false).then(data => {
      this.data = data;
      console.log(this.data);
    });
  }

  openTime(day: number) {
    console.log(this.data.days[day-1].status);
    if(this.data.days[day-1].status != '') {
      /* Warning for Sick or Vacation*/
      /*const alert = this.alertCtrl.create({
        title: 'Fehler!',
        subTitle: 'Dieser Tag kann nicht bearbeitet werden! <br><br><b>Grund: '+this.data.days[day-1].status+'</b>',
        buttons: ['OK']
      });
      alert.present();
      */
      this.navCtrl.push(WebfleetReportPage, {data: this.data, day: day});
    } else {
      this.navCtrl.push(WebfleetReportPage, {data: this.data, day: day});
    }
  }

  openWeekOverview() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Kalenderwochen');

    let Y = new Date().getFullYear();
    Y = Y-1;
    alert.addInput({
      type: 'radio',
      label: '51. Kalenderwoche('+Y+')',
      value: '-2',
      checked: false
    });
    alert.addInput({
      type: 'radio',
      label: '52. Kalenderwoche('+Y+')',
      value: '-1',
      checked: false
    });

    for(let i = this.getWeek()+1;i>=1;i--) {
      let checked = false;
      if(i == this.week) {
        checked = true;
      }
      alert.addInput({
        type: 'radio',
        label: i+'. Kalenderwoche',
        value: ''+i+'',
        checked: checked
      });
    }


    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'OK',
      handler: data => {
        this.week = data;
        this.loadOverview();
      }
    });
    alert.present();
  }

  getWeek() {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
        - 3 + (week1.getDay() + 6) % 7) / 7);
  }

  refreshOverview(event: any) {
    this.loadOverview();
    event.complete();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WebfleetReportOverviewPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/webfleet-report-overview/webfleet-report-overview.ts